import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarLibroExhortosLibradosParams, BuscarLibroExhortosLibradosResponse, defaultBuscarLibroExhortosLibradosResponse, DescargarInformacionParams, GuardarObservaciones } from '../../interfaces/libros-electronicos/LibroExhortosLibradosInterface';

export const ObtenerLibroExhortosLibrados = ( params: BuscarLibroExhortosLibradosParams ) => {

    return new Promise<BuscarLibroExhortosLibradosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/LibroExhortosLibrados/ObtenerLibroExhortosLibrados', params, token)
            .then(({ data }: { data: BuscarLibroExhortosLibradosResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve({ ...defaultBuscarLibroExhortosLibradosResponse });
            });

        }

    });

}

export const GuardarObservacionesLibroExhortosLibrados = ( params: GuardarObservaciones ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/LibroExhortosLibrados/GuardarObservaciones', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const DescargarLibroExhortosLibrados = ( params: DescargarInformacionParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/LibroExhortosLibrados/DescargarInformacion', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
